import {AdminUserStateInterface} from "./interfaces/state.interface";

export const AdminUserInitialStateConstant: AdminUserStateInterface = {
    adminUsers: []
};